module.exports = __webpack_public_path__ + "static/media/school.b473427f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/school.svg
// module id = 109
// module chunks = 0